import { useNavigate } from 'react-router-dom';
import { ConfirmationModal } from './ConfirmationModal';

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  /**
   * Subject phrase naming the gated feature, e.g. "Itinerary creation".
   * The message becomes "<feature> is for logged-in users only."
   */
  feature: string;
}

/**
 * Shown when an anonymous user tries to use a logged-in-only feature
 * (favorites, itineraries). Confirming sends them to the login page.
 */
export const LoginPromptModal = ({ isOpen, onClose, feature }: LoginPromptModalProps) => {
  const navigate = useNavigate();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={() => navigate('/login')}
      title="Sign in to continue"
      message={`${feature} is for logged-in users only. Log in or create an account to continue.`}
      confirmText="Log in or Create Account"
      cancelText="Cancel"
    />
  );
};
